export enum InvoicePackageGroup {
  Location = 'Location',
  Category = 'Category'
}
